import { useMutation } from '@apollo/client';
import { ResidentialCreate } from '@bakerweb/models';
import { toast } from 'react-toastify';
import { CREATE_RESIDENTIAL_MUTATION } from '../graphql/mutations/createResidential';

export function useCreateResidential() {
  const [createResidentialMutation, { data, loading, error }] = useMutation(CREATE_RESIDENTIAL_MUTATION);

  const createResidential = async (residentialCreateDto: ResidentialCreate) => {
    try {
      const response = await createResidentialMutation({
        variables: { residentialCreateDto }
      });
      toast.success('Your inquiry is on the way!');
      return response;
    } catch (err) {
      toast.error(`There was an error sending your request. Please try again.`);
      return null;
    }
  };

  return { createResidential, data, loading, error };
}
